import { DiscountType } from '@trnsact/trnsact-shared-types';

import { QuoteEquipmentAttachmentWithCharge, QuoteEquipmentWithCharge } from '../types';

class EquipmentCalc {
  private toPercent(amount: number) {
    return amount / 100;
  }

  public calcRetailPrice(charge: QuoteEquipmentWithCharge) {
    const {
      price: { wholesalePrice, markup, markupType },
    } = charge;

    if (markupType === DiscountType.Flat) return wholesalePrice + markup;
    if (markupType === DiscountType.Percent) return wholesalePrice + wholesalePrice * this.toPercent(markup);

    throw new Error('Unrecognized value for charge.');
  }

  public calcNetPrice(charge: QuoteEquipmentWithCharge) {
    const retailPrice = this.calcRetailPrice(charge);

    const {
      price: { discount, discountType },
    } = charge;

    if (discountType === DiscountType.Flat) return retailPrice - discount;
    if (discountType === DiscountType.Percent) return retailPrice - retailPrice * this.toPercent(discount);

    throw new Error('Unrecognized value for charge.');
  }

  public calcAttachmentsRetailPrice(attachment: QuoteEquipmentAttachmentWithCharge) {
    const {
      price: { wholesalePrice, markup, markupType },
    } = attachment;

    if (markupType === DiscountType.Flat) return wholesalePrice + markup;
    if (markupType === DiscountType.Percent) return wholesalePrice + wholesalePrice * this.toPercent(markup);

    throw new Error('Unrecognized value for charge.');
  }

  public calcAttachmentsNetPrice(attachment: QuoteEquipmentAttachmentWithCharge) {
    const retailPrice = this.calcAttachmentsRetailPrice(attachment);

    const {
      price: { discount, discountType },
    } = attachment;

    if (discountType === DiscountType.Flat) return retailPrice - discount;
    if (discountType === DiscountType.Percent) return retailPrice - retailPrice * this.toPercent(discount);

    throw new Error('Unrecognized value for charge.');
  }
}

export const equipmentCalc = new EquipmentCalc();
